import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  icon: {
    fontSize: 24,
    width: 24,
    height: 24,
  },
  root: {
    marginBottom: 10,
  },
  input: {
    width: '100%',
  },
  resetFieldButton: {
    width: 48,
    height: 48,
    padding: 12,
  },
  required: {
    fontSize: 12,
    color: 'red',
    position: 'absolute',
    top: 56,
    right: 0,
  },
}))

export default useStyles
